module.exports = __webpack_public_path__ + "static/media/hulu.de740eaf.jpg";